export default __webpack_public_path__ + "static/media/logo.382ac4e6.png";